import DataTable from "react-data-table-component";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import SamparkAdminLayout from "../../../components/SamparkAdminLayout/SamparkAdminLayout";

function HaribhaktTable() {
  const apiURL = process.env.REACT_APP_API_URL;
  const [haribhakts, setHaribhakts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [samparkId, setSamparkId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { samparks } = location?.state || {};
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const token = localStorage.getItem("token");
  const mandalId = localStorage.getItem("mandalDetailsId");
  const [attendanceData, setAttendanceData] = useState({});

  console.log(`samparks: ${JSON.stringify(samparks)}`);

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "SamparkAdmin") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const storedUserId = Number(localStorage.getItem("userId"));

    if (samparks.length > 0) {
      const foundSampark = samparks.find(
        (sampark) => sampark.userId === storedUserId
      );

      if (foundSampark) {
        setSamparkId(foundSampark.id);
      } else {
        setSamparkId(null);
      }
    }
  }, [samparks]);

  useEffect(() => {
    if (samparkId) {
      fetchData();
    }
  }, [samparkId, samparks]);

  const fetchData = async () => {
    if (!samparkId) return;

    try {
      const response = await axios.get(
        `${apiURL}/GroupDetails/GetbySamparkEmployeId?samparkEmployeId=${samparkId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      console.log(`response: ${response.data}`);
      const data = response?.data?.data;
      console.log(`data: ${JSON.stringify(data)}`);
      setHaribhakts(data);

      setLoading(false);
      console.log("Data fetched successfully!");
    } catch (error) {
      setLoading(false);
      toast.error(error.response?.data);
      setHaribhakts([]); // Prevent errors by ensuring haribhakts is always an array
    }
  };

  useEffect(() => {
    const fetchAttendanceForAll = async () => {
      if (!Array.isArray(haribhakts) || haribhakts.length === 0) {
        console.error("haribhakts is not an array or is empty", haribhakts);
        return;
      }

      let attendanceSummary = {};

      for (let haribhakt of haribhakts) {
        let config = {
          method: "get",
          url: `${apiURL}/UserAttendence/GetByList?haribhaktId=${haribhakt.id}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };

        try {
          const response = await axios.request(config);
          if (response.data.status) {
            const records = response.data.data;
            let uniqueDates = {};
            let present = 0;

            records.forEach((record) => {
              if (!uniqueDates[record.date]) {
                uniqueDates[record.date] = record.attendenceStatus;
              }
            });

            let totalRecords = Object.keys(uniqueDates).length;
            Object.values(uniqueDates).forEach((status) => {
              if (status) present++;
            });

            attendanceSummary[haribhakt.id] = { totalRecords, present };
          }
        } catch (error) {
          console.error(
            `Error fetching attendance for Haribhakt ${haribhakt.id}:`,
            error
          );
        }
      }

      setAttendanceData(attendanceSummary);
    };

    fetchAttendanceForAll();
  }, [haribhakts]);

  const columns = [
    {
      name: "No",
      selector: (row, index) =>
        `${(currentPage - 1) * rowsPerPage + index + 1}`,
      sortable: true,
      width: "65px",
      center: "true",
    },
    {
      name: "Photo",
      selector: (row) => row.imagePath,
      cell: (row) => (
        <img
          src={row.imageBase64 ? row.imageBase64 : "dist/img/user.png"}
          alt="img"
          style={{ width: "75px", height: "auto" }}
        />
      ),
      width: "100px",
      center: "true",
    },
    {
      name: "Name(Total Sabha/Total Aattendance)",
      selector: (row) => {
        const attendance = attendanceData[row.id] || {
          totalRecords: 0,
          present: 0,
        };

        return (
          <div>
            {row.firstName} {row.lastName} {row.surName} &nbsp;
            <span style={{ color: "green", fontWeight: "bold" }}>
              ({attendance.present}
            </span>
            <span
              style={{
                color: "blue",
                fontWeight: "bold",
              }}
            >
              /{attendance.totalRecords})
            </span>
          </div>
        );
      },
      sortable: true,
      width: "400px",
    },

    {
      name: "Mobile Number",
      selector: (row) => {
        const contactNumbers = [row.contactNo, row.contactNo1, row.contactNo2];
        const contactInfo =
          contactNumbers.filter(Boolean).join("<br />") ||
          "No contact available";
        return <div dangerouslySetInnerHTML={{ __html: contactInfo }} />;
      },
    },

    {
      name: "Address",
      selector: (row) =>
        row.houseNo + ", " + row.street + ", " + (row.address || ""),
    },

    {
      name: "Actions",
      width: "120px",
      cell: (row) => (
        <div>
          <button
            type="button"
            className="btn btn-primary btn-sm mr-1"
            onClick={() =>
              navigate("/update-haribhakt4", {
                state: {
                  id: mandalId,
                  haribhaktId: row.id,
                  samparks: samparks,
                },
              })
            }
          >
            <i className="fas fa-pen"></i>
          </button>
        </div>
      ),
      center: "true",
    },
  ];

  return (
    <SamparkAdminLayout ac8="active" samparks={samparks}>
      <section className="content-header pb-0">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h5>Haribhakt Details</h5>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/sampark-admin-dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Haribhakt List</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="d-flex justify-content-between">
                    <div className="bd-highlight">
                      <input
                        className="form-control mb-3"
                        type="search"
                        placeholder="Search"
                        title="Search within table"
                      />
                    </div>
                    <div className="bd-highlight"></div>
                  </div>
                </div>
                <div className="card-body text-center">
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm "
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </>
                  ) : (
                    <DataTable
                      columns={columns}
                      data={haribhakts}
                      pagination
                      responsive
                      className="custom-table"
                      onChangePage={(page) => setCurrentPage(page)}
                      onChangeRowsPerPage={(newPerPage) => {
                        setRowsPerPage(newPerPage);
                        setCurrentPage(1);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" style={{ width: "auto" }} />
    </SamparkAdminLayout>
  );
}

export default HaribhaktTable;
